export default "__VITE_ASSET__Co2Dc8Mt__"